import React, { Component } from "react";
import {Card, Form, Button, Row, Col, Alert, Tab, Tabs, Modal, Badge} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { withRouter } from '../../common/with-router';
import AsyncSelect from 'react-select/async';
import {FaCheck, FaQuestionCircle} from "react-icons/fa";
import { tiposCampos } from '../../common/utils';
import OpcoesCheckboxEditor from "./OpcoesCheckboxEditor";
import 'react-quill/dist/quill.snow.css'

class CamposPersonalizadosEdit extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.enviaRegistro = this.enviaRegistro.bind(this);

        this.fileInput = React.createRef();

        this.state = {
            erroLoadRegistro: "",
            campo_personalizado_id: "",
            titulo_pagina: "",
            loading: false,
            programas_list: [{programa_id: null, programa__nome: '', secao: '', gerar_historico: false}],
            programas_register: [],
            nome: '',
            slug: '', 
            descricao: '', 
            ordem: '', 
            tipo: '',
            obrigatorio: '', 
            extencoes_permitidas: '', 
            opcoes: '', 
            mascara: '',
            showMascaraHelp: false,
        };
    }

    componentDidMount() {
        const id = this.props.router.params.id;
    
        if (id) {
            this.setState({
                campo_personalizado_id: id,
                titulo_pagina: 'Editando Campos Personalizados Paciente',
                loading: true,
                erroLoadRegistro: ''
            });

            api.get(`/pessoas/beneficiarios/campos/${id}/`)
            .then(response => {
                const dados = response.data;
                const mascaraAtual = (dados.mascara || '').toString();
                const isInformacao = dados.tipo === 'texto' && mascaraAtual.includes('information-field');

                this.setState({
                    erroLoadRegistro: '',
                    nome: dados.nome,
                    slug: dados.slug,
                    descricao: dados.descricao,
                    ordem: dados.ordem,
                    tipo: isInformacao ? 'informacao' : dados.tipo,
                    obrigatorio: dados.obrigatorio,
                    extencoes_permitidas: dados.extencoes_permitidas,
                    opcoes: dados.opcoes,
                    mascara: mascaraAtual,
                    programas_list: dados.programas_list,
                    loading: false
                });
            })
                .catch(error => {
                    let erro_msg = 'Erro ao carregar campos personalizados, tente novamente';
    
                    if (error.response && error.response.status === 500) {
                        erro_msg = 'Servidor indisponível no momento, tente novamente';
                    }
    
                    this.setState({
                        erroLoadRegistro: erro_msg,
                        loading: false
                    });
                });
        } else {
            this.setState({
                campo_personalizado_id: '',
                titulo_pagina: 'Adicionar Campo Personalizado Paciente',
                loading: false,
                erroLoadRegistro: '',
            });
        }
    }

    splitMascaraTopLevel = (mascara = '') => {
        const tokens = [];
        let atual = '';
        let bracketDepth = 0;

        for (const ch of (mascara || '')) {
            if (ch === '[') bracketDepth += 1;
            if (ch === ']') bracketDepth = Math.max(0, bracketDepth - 1);

            if (ch === '|' && bracketDepth === 0) {
                tokens.push(atual);
                atual = '';
                continue;
            }

            atual += ch;
        }

        if (atual) tokens.push(atual);
        return tokens;
    };

    normalizeMascara = (mascara = '') => {
        if (!mascara || typeof mascara !== 'string') return '';

        let normalized = mascara
            .trim()
            .replace(/\s*\|\s*/g, '|')
            .replace(/\|{2,}/g, '|')
            .replace(/^\||\|$/g, '');

        normalized = normalized.replace(
            /(show-on(?:-any|-all)?\[[^\]]*?)(?=\|(information-field|policy-accept|position-bottom|divisor|context=(?:new|edit|both)|minLength=\d+|maxLength=\d+|position-(?:after|before)=))/gi,
            '$1]'
        );

        const tokens = this.splitMascaraTopLevel(normalized)
            .map(token => token.trim())
            .filter(Boolean)
            .map((token) => {
                if (/^show-on(?:-any|-all)?\[/i.test(token) && !token.includes(']')) {
                    return `${token}]`;
                }
                return token;
            });

        return tokens.join('|');
    };

    enviaRegistro = (e) => {
        e.preventDefault();

        this.setState({
            loading: true,
            tipoHelper: "",
            cidIdHelper: ""
        });

        //vererifica se é edição ou adição
        const url = (this.state.campo_personalizado_id) ? '/pessoas/beneficiarios/campos/'+this.state.campo_personalizado_id+'/' : '/pessoas/beneficiarios/campos/'
        const metodo = (this.state.campo_personalizado_id) ? 'put' : 'post'

        const mascaraNormalizada = this.normalizeMascara(this.state.mascara || '');
        const mascaraTokens = this.splitMascaraTopLevel(mascaraNormalizada)
            .map(token => token.trim())
            .filter(Boolean);

        const isInformacao = this.state.tipo === 'informacao';
        const tipoPayload = isInformacao ? 'texto' : this.state.tipo;

        if (isInformacao && !mascaraTokens.includes('information-field')) {
            mascaraTokens.push('information-field');
        }

        const mascaraPayload = mascaraTokens.join('|');

        let payload = {
            nome: this.state.nome,
            slug: this.state.slug,
            tipo: tipoPayload,
            status: true,   
            programas_register: this.state.programas_list.map(programa => ({
                programa_id: programa.programa_id,
                programa__nome: programa.programa__nome,
                secao: programa.secao,
                gerar_historico: programa.gerar_historico,
            }))
        };

        if(this.state.descricao) {
            payload['descricao'] = this.state.descricao;
        }
        if(mascaraPayload) {
            payload['mascara'] = mascaraPayload;
        }
        if(this.state.ordem) {
            payload['ordem'] = this.state.ordem;
        }
        if(this.state.opcoes) {
            payload['opcoes'] = this.state.opcoes;
          }
        if(this.state.obrigatorio) {
            payload['obrigatorio'] = this.state.obrigatorio;
          }
        if(this.state.extencoes_permitidas) {
            payload['extencoes_permitidas'] = this.state.extencoes_permitidas;
          }

        //envia para api
        api({
            method: metodo,
            url: url,
            data: payload,
        })
        .then(response => {
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.campo_personalizado_id) ? 'Campo personalizado atualizado com sucesso' : 'Campo personalizado cadastrado com sucesso';

            MySwal.fire({
                title: 'Sucesso!',
                html: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })
            
            this.setState({
                loading: false,
            })
            
            //redireciona
            if(!this.state.campo_personalizado_id){
                this.props.router.navigate("/campos-personalizados");
            }
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar campo personalizado paciente, verifique os campos e tente novamente';            

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                for (let key in campos){
                    var value = campos[key];
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    };

    carregarProgramas = async (inputValue) => {
        try {
            const response = await api.get(`/programas/?nome=${inputValue}`);
            const opcoes = response.data.results.map(programa => ({
                value: programa.id,
                label: programa.nome
            }));
            return opcoes;
        } catch (error) {
            console.error('Erro ao carregar programas:', error);
            return [];
        }
    };

    adicionarPrograma() {
        this.setState(prevState => ({
            programas_list: [...prevState.programas_list, { programa_id: null, programa__nome: '', secao: '', gerar_historico: false }],
        }));
    }

    removerPrograma(index) {
        this.setState(prevState => ({
            programas_list: prevState.programas_list.filter((_, i) => i !== index),
        }));
    }

    handleChange = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            const { value, label } = event;
            this.setState({
                [fieldName]: value,
                programa__nome: label,
            });
        } else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    handleChangePrograma(index, selectedOption) {
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index] = {
                ...programas_list[index],
                programa_id: selectedOption.value,
                programa__nome: selectedOption.label,
            };
            return { programas_list };
        });
    }

    handleSecaoChange(index, event) {
        const { value } = event.target;
        this.setState(prevState => {
            const programas_list = [...prevState.programas_list];
            programas_list[index].secao = value;
            return { programas_list };
        });
    }

    toggleGerarHistorico = (index) => {
        const programas = [...this.state.programas_list];
        programas[index] = {
            ...programas[index],
            gerar_historico: !programas[index].gerar_historico,
        };
        this.setState({ programas_list: programas });
    };
    
    render(){
        return (
            <>
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>
                <Tabs defaultActiveKey="dadosCampos" id="tabs-campos" className="aditus-tabs">
                    <Tab eventKey="dadosCampos" title="Dados do Campo Personalizado Paciente"> 
                            <Card className="cardDestaque">
                                <Card.Body>                    
                                    <Form onSubmit={this.enviaRegistro}>
                                        <h4>Campos Personalizado Paciente</h4>
                                                <Row>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Nome</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="nome" 
                                                                value={this.state.nome} 
                                                                onChange={e => this.handleChange(e, 'nome')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={6}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Tipo do Campo</Form.Label>
                                                            <Form.Control as="select" name="tipo" value={this.state.tipo} required onChange={e => this.handleChange(e, 'tipo')}>
                                                                <option value="">Tipo</option>
                                                                {Object.entries(tiposCampos).map(([sigla, nome]) => (
                                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                                ))}
                                                            </Form.Control>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Slug</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="slug"
                                                                value={this.state.slug} 
                                                                onChange={e => this.handleChange(e, 'slug')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Máscara para Campo{' '}
                                                                <FaQuestionCircle 
                                                                    style={{cursor: 'pointer', color: '#6c757d', fontSize: '0.9em'}} 
                                                                    onClick={() => this.setState({showMascaraHelp: true})}
                                                                    title="Clique para ver documentação das máscaras"
                                                                />
                                                            </Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="mascara" 
                                                                value={this.state.mascara} 
                                                                onChange={e => this.handleChange(e, 'mascara')} 
                                                            />
                                                            <div className="d-flex gap-2 mt-1 flex-wrap">
                                                                <Button variant="outline-secondary" size="sm" onClick={() => this.setState(prev => ({mascara: (prev.mascara ? prev.mascara + '|' : '') + 'divisor'}))} title="Adiciona divisor acima do campo">
                                                                    + Divisor
                                                                </Button>
                                                                <Button variant="outline-secondary" size="sm" onClick={() => this.setState(prev => ({mascara: (prev.mascara ? prev.mascara + '|' : '') + 'policy-accept'}))} title="Formata como termo de aceite">
                                                                    + Termo Aceite
                                                                </Button>
                                                                <Button variant="outline-secondary" size="sm" onClick={() => this.setState(prev => ({mascara: (prev.mascara ? prev.mascara + '|' : '') + 'position-bottom'}))} title="Move para o final do formulário">
                                                                    + Rodapé
                                                                </Button>
                                                            </div>
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Diretivas avançadas disponíveis - clique no ? para ver exemplos
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col sm={4}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Campo Obrigatório?</Form.Label>
                                                            <Form.Select className="form-control" name="obrigatorio" value={this.state.obrigatorio.toString()} onChange={e => this.handleChange(e, 'obrigatorio')}>
                                                                <option value="false">Não</option>
                                                                <option value="true">Sim</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {(this.state.tipo == 'selecao' || this.state.tipo == 'checkbox' || this.state.tipo == 'radio') && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Valores do Campo</Form.Label>
                                                            <div className="border rounded p-2 bg-white" style={{overflowX: 'auto'}}>
                                                                <div style={{minWidth: '760px'}}>
                                                                    <OpcoesCheckboxEditor
                                                                        value={this.state.opcoes}
                                                                        onChange={(newOpcoes) => this.setState({ opcoes: newOpcoes })}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                                Dica: use Nome para o titulo da pergunta e as opcoes para respostas (ex: "Sim, autorizo." e "Nao autorizo.").
                                                            </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                )}
                                                {(this.state.tipo == 'arquivo') && (
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Extensões Permitidas</Form.Label>
                                                            <Form.Control 
                                                                type="text" 
                                                                name="extencoes_permitidas" 
                                                                value={this.state.extencoes_permitidas} 
                                                                onChange={e => this.handleChange(e, 'extensoes_permitidas')} 
                                                            />
                                                        </Form.Group>
                                                        <Form.Text className="text-muted" style={{fontSize: '0.9em'}}>
                                                            Informe as extensões permitidas para o campo separadas por vírgula, por exemplo: .jpg, .png, .pdf
                                                        </Form.Text>
                                                    </Col>
                                                </Row>
                                                )}
                                                <Row>
                                                    <Col>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>Descrição</Form.Label>
                                                            <Form.Control 
                                                                as="textarea" 
                                                                name="descricao" 
                                                                value={this.state.descricao} 
                                                                onChange={e => this.handleChange(e, 'descricao')} 
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                <h4 className="mt-3">Programas</h4>
                                                {this.state.programas_list.map((programa, index) => (
                                                    <div key={index} className="row-list">
                                                        <Row>
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Programa</Form.Label>
                                                                    <AsyncSelect
                                                                        cacheOptions
                                                                        loadOptions={this.carregarProgramas}
                                                                        defaultOptions
                                                                        name="programa_id"
                                                                        placeholder="Buscar programa..."
                                                                        noOptionsMessage={() => "Nenhum programa encontrado"}
                                                                        onChange={e => this.handleChangePrograma(index, e)}
                                                                        value={programa.programa_id ? { value: programa.programa_id, label: programa.programa__nome } : null}
                                                                    />
                                                                    <Form.Text id="formProgramaHelpBlock" className="text-danger">{this.state.programaHelper}</Form.Text>
                                                                </Form.Group>
                                                            </Col>
                                                            {programa.programa_id && (
                                                            <Col sm={4} xs={12}>
                                                                <Form.Group className="mb-3">
                                                                    <Form.Label>Seção</Form.Label>
                                                                    <Form.Control 
                                                                        type="text" 
                                                                        name="secao" 
                                                                        value={programa.secao} 
                                                                        onChange={e => this.handleSecaoChange(index, e)} 
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            )}
                                                            {programa.programa_id && (
                                                                <Row>
                                                            <Col >
                                                                <Form.Group className="mb-3">
                                                                    <Form.Check 
                                                                        type="checkbox" 
                                                                        label="Gerar Histórico" 
                                                                        checked={programa.gerar_historico || false}
                                                                        onChange={() => this.toggleGerarHistorico(index)}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                            </Row>
                                                            )}
                                                            <Row>
                                                                <Col sm={2} xs={12}>
                                                                    <Button variant="secondary" className="btn-sm" onClick={() => this.adicionarPrograma(0)}>Adicionar Programa</Button>
                                                                </Col>
                                                                <Col sm={3} xs={12}>
                                                                    <Button variant="danger" className="btn-sm" onClick={() => this.removerPrograma(index)}> Remover Programa</Button>
                                                                </Col>
                                                            </Row>
                                                        </Row>
                                                    </div>
                                                ))}
                                                <Row>
                                                    <Col sm={4}>
                                                        <Button variant="success" className="btn-sm" onClick={this.enviaRegistro}>
                                                            <FaCheck className="me-1" /> Salvar Campo
                                                        </Button>&nbsp;&nbsp;
                                                    </Col>
                                                </Row>
                                    </Form> 
                                </Card.Body>                
                            </Card>
                    </Tab>
                </Tabs>
            </div>
            
            {/* Modal de Ajuda das Máscaras */}
            <Modal 
                show={this.state.showMascaraHelp} 
                onHide={() => this.setState({showMascaraHelp: false})} 
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Diretivas de Máscara para Campos Personalizados</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{maxHeight: '70vh', overflowY: 'auto'}}>
                    <Alert variant="info">
                        <strong>Como usar:</strong> As diretivas são separadas por <code>|</code> e podem ser combinadas livremente.
                    </Alert>
                    
                    <h5 className="mt-4">Posicionamento</h5>
                    <p>Posicione o campo em relação a outros campos (fixos ou personalizados):</p>
                    <ul>
                        <li>
                            <code>position-after=CAMPO</code> - Aparece após o campo especificado<br />
                            <small className="text-muted">Exemplo: <code>position-after=tipo_cuidador</code></small>
                        </li>
                        <li>
                            <code>position-before=CAMPO</code> - Aparece antes do campo especificado<br />
                            <small className="text-muted">Exemplo: <code>position-before=cuidador_nome</code></small>
                        </li>
                    </ul>
                    <Badge bg="secondary">Campos fixos: tipo_cuidador, cuidador_nome, cuidador_cpf, etc.</Badge>{' '}
                    <Badge bg="info">Campos personalizados: use o slug do campo</Badge>
                    
                    <h5 className="mt-4">👁️ Visibilidade Condicional</h5>
                    <p>Mostre o campo apenas quando uma condição for atendida:</p>
                    
                    <h6>Uma Condição</h6>
                    <ul>
                        <li>
                            <code>show-on[campo_paciente=CAMPO|campo_valor=VALOR]</code><br />
                            <small className="text-muted">Exemplo: <code>show-on[campo_paciente=tipo_cuidador|campo_valor=outro]</code></small>
                        </li>
                        <li>
                            <code>show-on[campo_extra=SLUG|campo_valor=VALOR]</code> - Para campos personalizados<br />
                            <small className="text-muted">Exemplo: <code>show-on[campo_extra=possui-condicao|campo_valor=sim]</code></small>
                        </li>
                    </ul>
                    
                    <h6>Múltiplas Condições (AND)</h6>
                    <Alert variant="success">
                        Combine múltiplas condições - TODAS precisam ser verdadeiras!
                    </Alert>
                    <p>Use múltiplos blocos <code>show-on[...]</code> separados por <code>|</code>:</p>
                    <div className="bg-light p-3 rounded mb-2">
                        <code>show-on[CONDIÇÃO1]|show-on[CONDIÇÃO2]|show-on[CONDIÇÃO3]</code>
                    </div>
                    <p><strong>Exemplo real:</strong> Campo aparece SOMENTE se paciente tem cuidador E campo personalizado está marcado:</p>
                    <div className="bg-light p-3 rounded mb-3">
                        <code>show-on[campo_paciente=vinculo_cuidador|campo_valor=true]|show-on[campo_extra=paciente-tem-cuidador|campo_valor=Sim]</code>
                    </div>
                    <ul className="mb-0">
                        <li>✅ Condição 1: <code>vinculo_cuidador = true</code> (campo fixo do paciente)</li>
                        <li>✅ Condição 2: <code>paciente-tem-cuidador = Sim</code> (campo personalizado)</li>
                        <li>⚠️ <strong>Ambas</strong> precisam ser verdadeiras para mostrar o campo!</li>
                    </ul>
                    
                    <h5 className="mt-4">Contexto (Novo/Edição)</h5>
                    <p>Controle em qual momento o campo aparece:</p>
                    <ul>
                        <li>
                            <code>context=new</code> - Apenas ao cadastrar novo paciente<br />
                            <small className="text-muted">Exemplo: Campo "Motivo do Cadastro"</small>
                        </li>
                        <li>
                            <code>context=edit</code> - Apenas ao editar paciente existente<br />
                            <small className="text-muted">Exemplo: Campo "Observações de Acompanhamento"</small>
                        </li>
                        <li>
                            <code>context=both</code> - Em ambos os contextos (padrão)
                        </li>
                    </ul>
                    
                    <h5 className="mt-4">Validação de Comprimento</h5>
                    <ul>
                        <li><code>min-length=N</code> - Comprimento mínimo do texto</li>
                        <li><code>max-length=N</code> - Comprimento máximo do texto</li>
                    </ul>

                    <h5 className="mt-4">Novas Diretivas de Layout</h5>
                    <ul>
                        <li>
                            <code>divisor</code> - Adiciona uma linha divisória acima do campo.
                        </li>
                        <li>
                            <code>policy-accept</code> - Formata o campo como um bloco de "Termo de Aceite" (ideal para checkboxes de consentimento).
                        </li>
                        <li>
                            <code>position-bottom</code> - Move o campo para o final do formulário, após todas as seções padrão.
                        </li>
                    </ul>
                    
                    <h5 className="mt-4">Campo Informativo</h5>
                    <ul>
                        <li>
                            <code>information-field</code> - Renderiza como Alert informativo (em vez de input)<br />
                            <small className="text-muted">O conteúdo vem da Descrição do campo</small>
                        </li>
                    </ul>

                    <h5 className="mt-4">⚠️ Alerta de Preenchimento (Novidade)</h5>
                    <p>Exibe um alerta persistente na tela de <strong>Atendimento</strong> (topo das informações do paciente) enquanto este campo não for preenchido.</p>
                    <p><strong>Configuração:</strong> Utilize o **Gerador de Regras (No-Code)** no menu principal para configurar o tipo &quot;Alerta Dinâmico (Persistent)&quot;. </p>
                    <ul>
                        <li>
                            <code>valor_campo=null.then(mensagemalerta=MENSAGEM)</code><br />
                            <small className="text-muted">Exemplo: <code>valor_campo=null.then(mensagemalerta=Confirmar melhor horário para contato)</code></small>
                        </li>
                    </ul>
                    <Alert variant="warning">
                        O alerta desaparecerá automaticamente assim que o campo receber qualquer valor.
                    </Alert>
                    
                    <h5 className="mt-4">Exemplos Práticos</h5>
                    
                    <div className="bg-light p-3 rounded mb-2">
                        <strong>Exemplo 1:</strong> Campo que aparece após tipo_cuidador somente quando {'"'}outro{'"'} é selecionado
                        <pre className="mb-0 mt-2"><code>show-on[campo_paciente=tipo_cuidador|campo_valor=outro]|position-after=tipo_cuidador</code></pre>
                    </div>
                    
                    <div className="bg-light p-3 rounded mb-2">
                        <strong>Exemplo 2:</strong> Campo apenas no cadastro, com validação de tamanho
                        <pre className="mb-0 mt-2"><code>context=new|min-length=10|max-length=200</code></pre>
                    </div>
                    
                    <div className="bg-light p-3 rounded mb-2">
                        <strong>Exemplo 3:</strong> Combinação completa
                        <pre className="mb-0 mt-2"><code>show-on[campo_paciente=tipo_cuidador|campo_valor=outro]|context=new|position-after=tipo_cuidador</code></pre>
                    </div>
                    
                    <div className="bg-light p-3 rounded mb-2">
                        <strong>Exemplo 4:</strong> Posicionar após outro campo personalizado
                        <pre className="mb-0 mt-2"><code>position-after=especifique-grau-parentesco</code></pre>
                        <small className="text-muted d-block mt-1">Use o slug do campo personalizado!</small>
                    </div>
                    
                    <Alert variant="warning" className="mt-4">
                        <strong>⚠️ Atenção:</strong> O <code>[]</code> fecha apenas na diretiva <code>show-on</code>. As outras diretivas não usam colchetes.
                    </Alert>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.setState({showMascaraHelp: false})}>
                        Fechar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        )
    }
}

export default withRouter(CamposPersonalizadosEdit);
